<template>
  <div>
    <div class="m-4 border-b py-2 text-2xl font-bold leading-7 text-gray-500 sm:truncate sm:text-3xl sm:tracking-tight">KPI Analysis</div>
    <ul role="list" class="m-4">
      <li v-for="(kpi, idx) in kpis" :key="idx" class="flex mb-2">
        <div class="flex-auto">
          <div class="flex items-baseline justify-between gap-x-4">
            <div class="text-md font-semibold leading-6 text-gray-900">{{ kpi.kpi }}</div>
            <div class="mr-4 text-md flex-none font-semibold text-gray-900">{{ kpi.score }}</div>
          </div>
          <equalizer-value class="my-1" :value="kpi.score" :max="10" :height="26" :reverse="true" color-mode="uniform"></equalizer-value>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import EqualizerValue from '@/components/Charts/EqualizerValue.vue';

  defineProps({
    kpis: {
      type: Array,
      default() {
        return [];
      },
    },
  });
</script>
